import React, { useState } from 'react';
import './Navbar.css';

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);

  const scrollToTop = (e) => {
    e.preventDefault();
    window.scrollTo({ top: 0, behavior: 'smooth' });
    setMenuOpen(false);
  };

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const section = document.getElementById(id);
    if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
    }
    setMenuOpen(false);
  };

  return (
    <nav className="navbar">
      <a href="#top" className="navbar-logo" onClick={scrollToTop}>
        <img src="/logo.png" alt="Royal Utsav Logo" className="logo-img" />
        <span>Royal Utsav</span>
      </a>

      <div className={`navbar-links ${menuOpen ? 'active' : ''}`}>
        <a href="#top" onClick={scrollToTop}>About Us</a>
        <a href="#makhana" onClick={(e) => scrollToSection(e, 'makhana')}>Makhana</a>
        <a href="#hair-care" onClick={(e) => scrollToSection(e, 'hair-care')}>Hair Care</a>
        <a href="#catalog" onClick={(e) => scrollToSection(e, 'catalog')}>Pricing</a>
        <a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact Us</a>
      </div>

      <div className="navbar-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        ☰
      </div>
    </nav>
  );
}

export default Navbar;